import React, { Component } from "react";
import { Modal } from "reactstrap";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import Globales from "utils/Globales";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import Chip from '@material-ui/core/Chip';
import { Clear, } from "@material-ui/icons";
import { Avatar } from "@material-ui/core";


class ModalMovimientosToefl extends Component {

  constructor(props, context) {
    super(props, context);
    this.escFunction = this.escFunction.bind(this);
    this.state = {
      colorNotificacion: "success",
      mensaje: "",
      br: false,
      ListaMovimientos: [],
      cargando: false
    }
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.props.eventClick(false);
    }
  }

  cerrarModal = () => {
    this.props.eventClick(false)
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
    console.log(this.props);
    this.ListarHistorialMovimientos(this.props.idAlumno)
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  //Función que habilita la notificación
  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ br: false, notificacion: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  async ListarHistorialMovimientos(idAlumno) {
    this.setState({ ListaMovimientos: [], cargando: true });

    let respuesta = await fetch(`${Globales.Url}Toefl/Toefl/ListarMovimientoToefl`, {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      },
      body: JSON.stringify({ idAlumno })
    })

    respuesta = await respuesta.json();

    if (respuesta.error) { //Error en la respuesta
      this.setState({ mensaje: respuesta.mensaje, colorNotificacion: "danger", cargando: false });
      this.showNotification();
    } else {
      const historial = respuesta.data.HistorialToefl;

      this.setState({
        ListaMovimientos: !historial ? [] : [].concat(historial),
        cargando: false
      });
    }
  }
  FormatearFecha(fecha) {
    if (!fecha) return "N/A";
    return new Date(fecha).toLocaleDateString("es-MX", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }
  FormatearTipoMovimiento(Tipo) {
    if (!Tipo) return null;
    const colores = {// Estados de error / fuera de flujo (Tonos Rojizos/Cálidos únicos)
      // --- ESTADOS NEGATIVOS / CANCELACIONES ---
      Rechazado: "#FFAB91",         // Rosa fuerte pastel (Distinto al rojo puro)
      Cancelado: "#f88585",         // Coral/Salmón (Indica detención)

      // --- ESTADO NEUTRO ---
      No_iniciado: "#CFD8DC",       // Gris azulado frío

      // --- FLUJO OPERATIVO ---
      Iniciado: "#C5E1A5",          // Verde lima muy claro (Punto de partida)
      Agendado: "#90CAF9",          // Azul cielo (Planificación)
      Reprogramado: "#FFD54F",      // Amarillo ámbar (Alerta de cambio/atención)

      // --- HITOS DE PROCESO ---
      Confirmado: "#4DD0E1",        // Cian/Turquesa (Seguridad y firmeza, sin ser morado)
      Examen_presentado: "#9FA8DA", // Indigo suave (Representa una acción formal ejecutada)

      // --- CIERRE Y RESULTADOS ---
      Evaluado: "#BCAAA4",          // Café/Grisáceo pastel (Color "papel/archivo" para revisión)
      Concluido: "#81C784",         // Verde bosque pastel (Éxito definitivo)
    };

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Avatar
          style={{
            backgroundColor: colores[Tipo] || "#E0E0E0",
            width: 20,
            height: 20,
          }}
        >
          {" "}
        </Avatar>
        <span style={{ color: "#333333" }}>
          {Tipo.replace(/_/g, " ").toUpperCase()}
        </span>
      </div>
    );
  }

  render() {
    let agregar;



    return (
      <Modal isOpen={this.props.show} centered size="lg" toggle={this.cerrarModal} backdrop={true} >
        <Card>
          <CardHeader color="info">Movimientos del alumno</CardHeader>
          <CardBody>
            <table>
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Movimiento</th>
                  <th>Comentarios</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.cargando &&
                  <tr>
                    <td colSpan="4" style={{ textAlign: "center" }}>
                      Cargando...
                    </td>
                  </tr>
                }

                {
                  (this.state.ListaMovimientos.length === 0 && !this.state.cargando) &&
                  <tr>
                    <td colSpan="4" style={{ textAlign: "center" }}>
                      No hay movimientos disponibles
                    </td>
                  </tr>
                }

                {
                  this.state.ListaMovimientos.map((historial, index) =>
                    <tr key={index}>
                      <td>{this.FormatearFecha(historial.FechaRegistro)}</td>
                      <td>{this.FormatearTipoMovimiento(historial.Movimiento)}</td>
                      <td>{historial.Motivos || "N/A"}</td>
                    </tr>
                  )
                }
              </tbody>
            </table>

            <GridItem xs={12} sm={12} md={12}>
              <Button tabIndex="1" size='sm' className='pull-right ml-2 mt-3' round onClick={() => this.props.eventClick(false)}><Clear />&nbsp;Cerrar</Button>
            </GridItem>

            <div id="">
              <Snackbar
                place="tr"
                color={this.state.colorNotificacion}
                message={this.state.mensaje}
                open={this.state.br}
                closeNotification={() => this.setState({ br: false })}
                close
              />
              {agregar}
            </div>
          </CardBody>
        </Card>
      </Modal>
    );
  }
}
export default withStyles(basicsStyle)(ModalMovimientosToefl);